import { BasicEvent } from "./BasicEvent";
export class ArbetsorderRestriktionUpdatedEventMessage extends BasicEvent {
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderRestriktionUpdatedEventMessage";
}
